import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  BATTERY_ERROR,
  BATTERY_LOADING,

  BATTERY_FILTERS,
  BATTERY_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/battery";

export const setLoading = (status) => ({
  type: BATTERY_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, scooterUrl)
    .then((response) => {
      dispatch({
        type: BATTERY_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BATTERY_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "status,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then((response) => {
      dispatch({
        type: BATTERY_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BATTERY_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/battery/actions.js